import "core-js/modules/es.array.concat";
import _classCallCheck from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "E:/\u5EAD\u5BA1\u9879\u76EE/trial_2.1.0_code/hikcourt-web/hikcourt-web/trial-web/node_modules/@babel/runtime/helpers/esm/createSuper";
import { __decorate } from "tslib";
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import echarts from 'echarts';

var CaseNumberChart = /*#__PURE__*/function (_Vue) {
  _inherits(CaseNumberChart, _Vue);

  var _super = _createSuper(CaseNumberChart);

  function CaseNumberChart() {
    var _this;

    _classCallCheck(this, CaseNumberChart);

    _this = _super.call(this);
    _this.activeIndex = 'count';
    _this.trialNumIcon = [require('./../../assets/icons/trialNumIcon.svg')];
    _this.trialHourCountIcon = [require('./../../assets/icons/trialHourCountIcon.svg')];
    _this.trialHourAvgIcon = [require('./../../assets/icons/trialHourAvgIcon.svg')];
    _this.activeChart = 0;
    _this.loading = true;
    return _this;
  }

  _createClass(CaseNumberChart, [{
    key: "watchMonthNumber",
    value: function watchMonthNumber(newval, old) {
      var _this2 = this;

      this.$nextTick().then(function (_) {
        if (_this2.activeChart === 0) {
          _this2.clearChart();

          _this2.loading = true;

          _this2.drawLine();
        }
      });
    }
  }, {
    key: "handleSelect",
    value: function handleSelect(index) {
      this.activeIndex = index;
      this.$refs.caseNumCarousel.setActiveItem(index);
    }
  }, {
    key: "selectChart",
    value: function selectChart(index) {
      if (this.activeChart !== index) {
        this.activeChart = index;
        this.clearChart();
        this.loading = true;
        this.drawLine();
      }
    }
  }, {
    key: "clearChart",
    value: function clearChart() {
      if (this.myChart) {
        this.myChart.clear();
        this.myChart.dispose();
      }
    }
  }, {
    key: "drawLine",
    value: function drawLine() {
      var _this3 = this;

      this.getCaseNumber();
      var option = {
        backgroundColor: '#F8F9FF',
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow',
            shadowStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(88, 34, 230, 0)'
                }, {
                  offset: 0.5,
                  color: 'rgba(93, 40, 233, 0.09)'
                }, {
                  offset: 1,
                  color: 'rgba(89, 35, 231, 0)'
                }],
                globalCoord: false
              }
            }
          },
          formatter: function formatter(params) {
            var chartType = _this3.activeChart === 0 ? '周' : '月';
            var chartIndex = parseInt(params[0].axisValueLabel) - 1;
            var chartDate = chartIndex === 0 ? '本' : "\u8FC7\u53BB\u7B2C ".concat(chartIndex, " ");
            var trialHourCount = _this3.activeChart === 0 ? _this3.monthCaseNumber[chartIndex].trialHourCount : _this3.yearCaseNumber[chartIndex].trialHourCount;
            var trialHourAvg = _this3.activeChart === 0 ? _this3.monthCaseNumber[chartIndex].trialHourAvg : _this3.yearCaseNumber[chartIndex].trialHourAvg;
            var listItem = "".concat(chartDate).concat(chartType, "\u6848\u4EF6\u60C5\u51B5<br>\n          <i style=\"display: inline-block;width: 10px;height: 10px;background: #FFBD00;margin-right: 5px;border-radius: 50%;}\"></i>\n          <span style=\"width:150px; display:inline-block;\">\u5EAD\u5BA1\u6B21\u6570 ").concat(params[0].data, " \u4EF6</span><br>\n          <i style=\"display: inline-block;width: 10px;height: 10px;background: #9AFF9A;margin-right: 5px;border-radius: 50%;}\"></i>\n          <span style=\"width:150px; display:inline-block;\">\u603B\u65F6\u95F4 ").concat(trialHourCount, " \u5C0F\u65F6</span><br>\n          <i style=\"display: inline-block;width: 10px;height: 10px;background: #87CEFF;margin-right: 5px;border-radius: 50%;}\"></i>\n          <span style=\"width:150px; display:inline-block;\">\u5E73\u5747\u65F6\u95F4 ").concat(trialHourAvg, " \u5C0F\u65F6</span>");
            return "<div class=\"showBox\">".concat(listItem, "</div>");
          }
        },
        grid: {
          top: '12%',
          left: '3%',
          right: '10%',
          bottom: '4%',
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          boundaryGap: false,
          data: this.activeChart === 0 ? this.monthCaseType : this.yearCaseType,
          name: this.activeChart === 0 ? '(周)' : '(月)',
          nameGap: 16,
          axisTick: {
            show: false
          },
          axisLabel: {
            color: '#666666',
            fontSize: 14,
            fontWeight: 600,
            margin: 8
          },
          axisLine: {
            show: false,
            lineStyle: {
              color: '#E5E5E5',
              width: 1
            }
          },
          splitLine: {
            show: true,
            lineStyle: {
              color: '#E5E5E5'
            }
          },
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 300,
            color: '#B3B1B1'
          }
        }],
        yAxis: {
          type: 'value',
          // name: '案件数量',
          boundaryGap: false,
          min: function min(value) {
            return value.min - 10 < 0 ? 0 : Math.floor((value.min - 10) / 10) * 10;
          },
          max: function max(value) {
            return Math.ceil((value.max + 10) / 10) * 10;
          },
          scale: true,
          axisTick: {
            show: true
          },
          axisLabel: {
            color: '#4C4C4C',
            fontSize: 14,
            fontWeight: 600,
            showMinLabel: false,
            showMaxLabel: false,
            margin: 12
          },
          axisLine: {
            lineStyle: {
              width: 1,
              color: '#E5E5E5'
            }
          },
          splitLine: {
            show: false
          },
          nameTextStyle: {
            fontSize: 16,
            fontWeight: 600,
            color: '#282640'
          }
        },
        series: [{
          type: 'line',
          smooth: true,
          symbol: 'circle',
          showSymbol: false,
          symbolSize: 1,
          data: this.caseNumber,
          itemStyle: {
            normal: {
              lineStyle: {
                color: {
                  type: 'linear',
                  x: 0,
                  y: 0,
                  x2: 1,
                  y2: 0,
                  colorStops: [{
                    offset: 0,
                    color: 'rgba(70, 0, 255, 0)'
                  }, {
                    offset: 0.25,
                    color: 'rgba(70, 0, 255, 0.56)'
                  }, {
                    offset: 0.5,
                    color: 'rgba(46, 65, 255, 1)'
                  }, {
                    offset: 0.75,
                    color: 'rgba(87, 33, 230, 1)'
                  }, {
                    offset: 1,
                    color: 'rgba(70, 0, 255, 0.4)'
                  }],
                  globalCoord: false
                },
                shadowOffsetX: 0,
                shadowOffsetY: 7,
                shadowBlur: 5,
                shadowColor: 'rgba(70, 0, 255, 0.25)',
                type: 'solid',
                width: 2
              },
              color: '#3A0CE3'
            }
          }
        }]
      };
      this.$nextTick().then(function () {
        _this3.myChart = echarts.init(document.getElementById('case-chart'));

        _this3.myChart.setOption(option);

        _this3.loading = false;
      });
    }
  }, {
    key: "getCaseNumber",
    value: function getCaseNumber() {
      this.caseNumber = [];

      if (this.activeChart === 0) {
        for (var i = 0; i < this.monthCaseNumber.length; i++) {
          this.caseNumber.push(this.monthCaseNumber[i].trialNum);
        }
      } else {
        for (var _i = 0; _i < this.yearCaseNumber.length; _i++) {
          this.caseNumber.push(this.yearCaseNumber[_i].trialNum);
        }
      }
    }
  }, {
    key: "beforeDestroy",
    value: function beforeDestroy() {
      this.clearChart();
    }
  }]);

  return CaseNumberChart;
}(Vue);

__decorate([Prop({
  type: Array,
  required: true
})], CaseNumberChart.prototype, "monthCaseNumber", void 0);

__decorate([Prop({
  type: Array,
  required: true
})], CaseNumberChart.prototype, "monthCaseType", void 0);

__decorate([Prop({
  type: Array,
  required: true
})], CaseNumberChart.prototype, "yearCaseNumber", void 0);

__decorate([Prop({
  type: Array,
  required: true
})], CaseNumberChart.prototype, "yearCaseType", void 0);

__decorate([Prop({
  type: Object,
  required: true,
  default: function _default() {
    return {
      trialNum: 0,
      trialHourCount: '0',
      trialHourAvg: '0'
    };
  }
})], CaseNumberChart.prototype, "statistic", void 0);

__decorate([Watch('monthCaseNumber')], CaseNumberChart.prototype, "watchMonthNumber", null);

CaseNumberChart = __decorate([Component], CaseNumberChart);
export default CaseNumberChart;